import { useDispatch } from 'react-redux';
import { AppDispatch } from 'shared/store/types';

export const useAppDispatch = () => useDispatch<AppDispatch>();
